import { render, staticRenderFns } from "./MainCarousel.vue?vue&type=template&id=9f582d4a"
import script from "./MainCarousel.vue?vue&type=script&lang=js"
export * from "./MainCarousel.vue?vue&type=script&lang=js"
import style0 from "./MainCarousel.vue?vue&type=style&index=0&id=9f582d4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports